import { useState } from "react";
import { useListContext, useTranslate } from "ra-core";
import { RadioTower } from "lucide-react";

import { Button } from "@/components/ui/button";

import type { Contact } from "../types";
import { WhatsAppBroadcastDialog } from "../whatsapp/WhatsAppBroadcastDialog";

export function BulkWhatsAppBroadcastButton() {
  const translate = useTranslate();
  const { selectedIds = [], onUnselectItems } = useListContext<Contact>();
  const [open, setOpen] = useState(false);

  if (!selectedIds.length) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-9"
        onClick={() => setOpen(true)}
      >
        <RadioTower className="size-4" />
        {translate("resources.contacts.broadcast.action")}
      </Button>
      <WhatsAppBroadcastDialog
        open={open}
        contactIds={selectedIds}
        onOpenChange={setOpen}
        onCreated={() => {
          onUnselectItems();
        }}
      />
    </>
  );
}
